export function boolProp(condition: boolean): boolean {
    return (condition ? 1 : undefined) as unknown as boolean;
}
